import Repository from "../../repository";

export default {
    Totals: (payload) => Repository.post(`/api/LightingReports/Totals`, payload),
    Details: (payload) => Repository.post(`/api/LightingReports/Details`, payload),
    CurrentTotals: (payload) => Repository.post(`/api/LightingReports/CurrentTotals`, payload),
    CurrentDetails: (payload) => Repository.post(`/api/LightingReports/CurrentDetails`, payload),
}
